"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DictionaryItem {
    constructor(id, definitions, values) {
        this.id = id;
        this.metadata = definitions;
        this.values = values;
    }
    getLocalizedValue(id, lcid) {
        const def = this.getAttributeDefinition(id);
        if (def.isLocalized !== true) {
            throw new Error(`Attribute ${id} is not localized`);
        }
        const keyValue = this.getAttributeValue(id) || {};
        const value = keyValue[lcid];
        return value;
    }
    getSingleValue(id) {
        const def = this.getAttributeDefinition(id);
        if (def.isMultiple === true) {
            throw new Error(`Attribute ${id} is not single`);
        }
        const value = this.getAttributeValue(id);
        return value;
    }
    getArrayValue(id) {
        const def = this.getAttributeDefinition(id);
        if (def.isMultiple !== true) {
            throw new Error(`Attribute ${id} is not multiple`);
        }
        const value = this.getAttributeValue(id);
        return value;
    }
    getValue(id) {
        const attrExist = this.metadata.has(id);
        if (!attrExist) {
            throw new Error(`Attribute ${id} does not exist`);
        }
        const value = this.getAttributeValue(id);
        return value;
    }
    getAttributeDefinition(id) {
        const def = this.metadata.get(id);
        if (def === undefined) {
            throw new Error(`Attribute ${id} does not exist`);
        }
        return def;
    }
    getAttributeValue(id) {
        // TODO: maybe add case-insensitive checks
        return this.values[id];
    }
}
exports.DictionaryItem = DictionaryItem;
//# sourceMappingURL=DictionaryItem.js.map